import axiosHttp from "../../services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardStatusList = createAsyncThunk("fetchRewardStatusList", async ({ identifier }) => {
	const response = await axiosHttp.get(`statuses?keyword=${identifier}`);
	return response.data.data;
});

const rewardStatusListSlice = createSlice({
	name: "rewardStatusList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardStatusList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default rewardStatusListSlice.reducer;
